import { createSlice } from '@reduxjs/toolkit';
import { loginUser, getUserDetails } from '../actions/authActions';
import { LOCAL_STORAGE_AUTH_NAME } from '../../constants/utils';
import api from '../../services/api';
import { ROUTES } from '../../constants/routes';

let requestInterceptor;
let authUserValue;
let userData;
let channelsList;
let channelsListForActualSpend;

try {
  authUserValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_AUTH_NAME));
} catch {
  localStorage.removeItem(LOCAL_STORAGE_AUTH_NAME);
  authUserValue = null;
}

try {
  channelsList = JSON.parse(localStorage.getItem('channelsList'));
} catch {
  localStorage.removeItem('channelsList');
}

try {
  userData = JSON.parse(localStorage.getItem('userData'));
} catch {
  localStorage.removeItem('userData');
  userData = {};
}

try {
  channelsListForActualSpend = JSON.parse(localStorage.getItem('channelsListForActualSpend'));
} catch {
  localStorage.removeItem('channelsListForActualSpend');
}

const initialState = {
  loading: false,
  isUserLoggedIn: !!authUserValue,
  error: null,
  success: false,
  userRefreshToken: authUserValue?.refresh || null,
  userAccessToken: null,
  userData: userData || {},
  isAdmin: userData?.data?.is_gale_admin || false,
  userStores: userData?.data?.stores_data || [],
  channelsList: channelsList || [],
  channelsListForActualSpend: channelsListForActualSpend || [],
  isSSOUser: false,
  redirectUrlAfterLogin: ROUTES.executiveSummaryOverallPerformance,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state, _action) {
      api.defaults.headers.common.Authorization = '';
      state.isUserLoggedIn = false;
      state.isAdmin = false;
      state.userAccessToken = null;
      state.userAccessToken = null;
      state.userRefreshToken = null;
      state.isSSOUser = false;
      api.interceptors.request.eject(requestInterceptor);
      state.isUserLoggedIn = false;
      state.isAdmin = false;
      state.userData = {};
      localStorage.removeItem(LOCAL_STORAGE_AUTH_NAME);
      localStorage.removeItem('userData');
      localStorage.removeItem('channelsList');
      localStorage.removeItem('channelsListForActualSpend');
      localStorage.removeItem('transformedData');
      localStorage.removeItem('transformDataWithDate');
      localStorage.clear();
      sessionStorage.removeItem('redirectAfterLogin');
      state.redirectUrlAfterLogin = ROUTES.executiveSummaryOverallPerformance;
    },
    setUserAccessToken(state, action) {
      state.userAccessToken = action.payload;
    },
    setChannelsList(state, action) {
      localStorage.setItem('channelsList', JSON.stringify(action.payload));
      state.channelsList = action.payload;
    },
    setChannelsListForActualSpend(state, action) {
      localStorage.setItem('channelsListForActualSpend', JSON.stringify(action.payload));
      state.channelsListForActualSpend = action.payload;
    },
    setLoggedInViaSSO(state, action) {
      state.isUserLoggedIn = true;
      state.isSSOUser = true;
      state.userAccessToken = action.payload.access;
      state.userRefreshToken = action.payload.refresh;
      if (localStorage.getItem(LOCAL_STORAGE_AUTH_NAME)) {
        api.interceptors.request.eject(requestInterceptor);
        requestInterceptor = api.interceptors.request.use(
          (config) => {
            const token = action.payload.access;

            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
      }
    },
    setRedirectUrlAfterLogin(state, action) {
      state.redirectUrlAfterLogin = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.userData = {};
      })
      .addCase(loginUser.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;
        state.isUserLoggedIn = true;
        state.userAccessToken = payload.access;
        state.userRefreshToken = payload.refresh;
        if (localStorage.getItem(LOCAL_STORAGE_AUTH_NAME)) {
          api.interceptors.request.eject(requestInterceptor);
          requestInterceptor = api.interceptors.request.use(
            (config) => {
              const token = payload.access;

              if (token) {
                config.headers.Authorization = `Bearer ${token}`;
              }
              return config;
            },
            (error) => Promise.reject(error)
          );
        }
      })
      .addCase(loginUser.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserDetails.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.error = null;
        state.userData = payload;
        state.isAdmin = payload?.data?.is_gale_admin;
        state.userStores = payload.data?.stores_data;
        localStorage.setItem('userData', JSON.stringify(state.userData));
      })
      .addCase(getUserDetails.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const {
  logout,
  setUserAccessToken,
  setChannelsList,
  setChannelsListForActualSpend,
  setLoggedInViaSSO,
  setRedirectUrlAfterLogin,
} = authSlice.actions;
export default authSlice.reducer;
